const menuInit = () => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const navbar = document.querySelector('header .navbar');
    const header = document.querySelector('header');
    const contactBar = document.querySelector('.kruse-contact-bar');
    const toggler = navbar.querySelector('.navbar-toggler');
    const theMenu = document.querySelector('.kruse-main-menu');
    toggler.addEventListener('click', ev => {
        if (toggler.classList.contains('collapsed')) {
            let scrollTo = toggler.getAttribute('data-scroll-y');
            window.scrollTo({top: scrollTo * 1, left: 0, behavior: "instant"});
            document.body.classList.remove('menu-open');
        } else {
            toggler.setAttribute('data-scroll-y', window.scrollY);
            document.body.classList.add('menu-open');
            // make sure top of menu is visible on smaller mobile screens that require menu scrolling (column-reverse issue)
            setTimeout(()=>{
                theMenu.scrollTop = -theMenu.scrollHeight;
            }, 500)

        }
    })
    let contactBarLinks = [];
    if (contactBar !== null) {
        contactBarLinks = contactBar.querySelectorAll('a');
    }

    let scrollHeight;
    const minificationBreakpoint = 90;

    // let navbarCollapseBreakpoint = window.matchMedia("screen and (min-width: 1199px)");
    let last_known_scroll_position = 0;
    let ticking = false;
    window.addEventListener('scroll', function () {
        const scrolledLogo = document.querySelector('.krusescan-primary-logo__scrolled');

        // const matches = navbarCollapseBreakpoint.matches ? navbarCollapseBreakpoint.matches : navbarCollapseBreakpoint.msMatchesSelector;
        if (document.body.classList.contains('menu-open')) return;
        if (vw > 1024) {
            collapseNavbar(window.scrollY);
            showContentList(window.scrollY);
        }
        if (vw < 1025) {
            let previous_known_scroll_position = last_known_scroll_position;
            last_known_scroll_position = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    scrollEventThrottle(last_known_scroll_position, previous_known_scroll_position);
                    ticking = false;
                });
                ticking = true;
            }
            showContentList(window.scrollY);
        }
    });
    const scrollEventThrottle = ((scrollPos, previousScrollPos) => {
        let documentHeight = document.body.offsetHeight;
        if (documentHeight <= (scrollPos + window.innerHeight)) {
            navbar.classList.remove('minified');
            header.classList.remove('minified');
            if (contactBar !== null) {
                contactBar.classList.add('kruse-contact-bar-visible')
                if (contactBarLinks.length > 0) {
                    contactBarLinks.forEach(l => {
                        l.setAttribute('tabindex', -1)
                    })
                }
            }
        } else if (previousScrollPos > scrollPos || scrollPos < 50) {
            navbar.classList.remove('minified');
            header.classList.remove('minified');
            if (contactBar !== null) {
                contactBar.classList.remove('kruse-contact-bar-visible')
                if (contactBarLinks.length > 0) {
                    contactBarLinks.forEach(l => {
                        l.setAttribute('tabindex', 1)
                    })
                }
            }
        } else {
            navbar.classList.add('minified');
            header.classList.add('minified');
            if (contactBar !== null) {
                contactBar.classList.add('kruse-contact-bar-visible')
                if (contactBarLinks.length > 0) {
                    contactBarLinks.forEach(l => {
                        l.setAttribute('tabindex', -1)
                    })
                }
            }
        }
    });

    function collapseNavbar(scrollY) {
        if (scrollY >= minificationBreakpoint && !navbar.classList.contains('minified')) {
            navbar.classList.add('minified');
            header.classList.add('minified');
            if (contactBar !== null) {
                contactBar.classList.add('kruse-contact-bar-visible')
                if (contactBarLinks.length > 0) {
                    contactBarLinks.forEach(l => {
                        l.setAttribute('tabindex', 1)
                    })
                }
            }
        } else if (scrollY < minificationBreakpoint) {
            navbar.classList.remove('minified');
            header.classList.remove('minified');
            if (contactBar !== null) {
                contactBar.classList.remove('kruse-contact-bar-visible')
                if (contactBarLinks.length > 0) {
                    contactBarLinks.forEach(l => {
                        l.setAttribute('tabindex', -1)
                    })
                }
            }
        }
    }

    function showContentList(scrollY) {
        const firstCover = document.querySelector('.wp-block-cover ');
        const markerHolder = document.querySelector('.kruse-section-block--anchor-holder');
        if (markerHolder !== null) {
            let checkFor = firstCover ? firstCover.scrollHeight : 0;
            const triggerButton = markerHolder.querySelector('.kruse-section-block--trigger');
            if (scrollY >= checkFor && !markerHolder.classList.contains('kruse-section-block--anchor-holder-shown')) {
                markerHolder.classList.add('kruse-section-block--anchor-holder-shown');
                triggerButton.setAttribute('tabindex', '0')
                //triggerButton.focus();

            } else if (scrollY < checkFor) {
                markerHolder.classList.remove('kruse-section-block--anchor-holder-shown');
                triggerButton.setAttribute('tabindex', '-1')

            }
        }

    }

}
export default menuInit;